import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { formateDateTime, validateFormGroup } from '@utils/utils';
import { AtlasGridTranslateRendererComponent } from '@ui/components/atlas-grid/renderer/translate-renderer.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AtlasToastService } from '@services/atlas-toast.service';
import { AtlasGridHtmlRendererComponent } from '@ui/components/atlas-grid/renderer/html-renderer.component';
import { UserService } from '@services/user.service';
import { Subject, Subscription } from 'rxjs';
import { ButtonGroupRendererComponent } from '@ui/components/atlas-grid/renderer/buttongroup-renderer.component';
import { AtlasGridComponent } from '@ui/components/atlas-grid/atlas-grid.component';
import { DomainService } from '@services/domain.service';
import * as _ from 'lodash';
import { ResellerSendersService } from '@services/reseller-senders.service';
import { ResellerSubSenderAgcom } from '@models/reseller/sub-senders';
import { SubaccountService } from '@services/subaccount.service';
import { debounceTime, finalize } from 'rxjs/operators';
import { ApiGetSubaccounts } from '@models/subaccount/subaccount';
import { AtlasGridOptions } from '@ui/components/atlas-grid/altas-grid-options.model';
import { GridReadyEvent } from 'ag-grid-community';
import { LoaderService } from '@services/loader.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'wsb-reseller-senders',
  templateUrl: './reseller-senders.component.html',
  styleUrls: ['./reseller-senders.component.scss'],
  animations: [
    trigger('gridIsLoaded', [
      state('hide', style({ opacity: 0 })),
      state('show', style({ opacity: 1 })),
      transition('hide => show', animate('150ms', style({ opacity: 1 }))),
      transition('show => hide', animate('150ms', style({ opacity: 0 })))
    ])
  ],
  standalone: false
})
export class ResellerSendersComponent implements OnInit, OnDestroy {
  hasValidatedSendersList = false;

  @ViewChild('alphaGrid') alphaGrid: AtlasGridComponent;
  @ViewChild('modalAddEditAlpha') modalAddEditAlpha;
  @ViewChild('modalAddEditAlphaDisabled') modalAddEditAlphaDisabled;
  @ViewChild('modalDeleteAlpha') modalDeleteAlpha;
  modalAddEditAlphaModal: NgbModalRef;
  modalAddEditAlphaDisabledModal: NgbModalRef;
  modalDeleteAlphaModal: NgbModalRef;

  @ViewChild('numericGrid') numericGrid: AtlasGridComponent;
  @ViewChild('modalAddNumeric') modalAddNumeric;
  @ViewChild('modalDeleteNumeric') modalDeleteNumeric;
  modalAddNumericModal: NgbModalRef;
  modalAddNumericModalConfirm: NgbModalRef;
  modalDeleteNumericModal: NgbModalRef;

  tableResellSendersNumericColumnDefs = null;
  tableResellSendersNumericGridOptions = null;
  tableSendersNumericLoading: boolean;

  tableResellSendersAlphaColumnDefs = null;
  tableResellSendersAlphaGridOptions = null;
  tableResellSendersAlphaLoading: boolean;

  subSenderToDelete: ResellerSubSenderAgcom;
  senderToConfirm: ResellerSubSenderAgcom;

  addResellSenderAlphaForm: UntypedFormGroup = null;
  addResellSenderNumericForm: UntypedFormGroup = null;
  confirmNumericSenderForm: UntypedFormGroup = null;

  canManageAlphaSenders = true;
  scrollPageSubs = 1;

  private search: Subject<string> = new Subject();

  private isCustomer;
  private isSubAccount;
  private userSubscription: Subscription;
  paginationPageSize = 10;
  components = {
    buttonGroupRenderer: ButtonGroupRendererComponent,
    translateRenderer: AtlasGridTranslateRendererComponent,
    htmlRenderer: AtlasGridHtmlRendererComponent
  };

  statusMap = {
    UNCONFIRMED: 'agcom_tpoa_status_0',
    ERROR_DURING_UPLOAD: 'agcom_tpoa_status_0',
    CONFIRMEDBYAGCOM: 'agcom_tpoa_status_2',
    PRECONFIRMEDBYONEETERE: 'agcom_tpoa_status_2',
    CONFIRMEDBYONEETERE: 'agcom_tpoa_status_2',
    BLOCKEDBYAGCOM: 'agcom_tpoa_status_3',
    BLOCKEDBYONEETERE: 'agcom_tpoa_status_3'
  };

  itemsSubaccounts: Array<{ value: number; label: string }> = [];
  gridAnimationStateAlpha = 'hide';
  gridAnimationStateNumeric = 'hide';

  constructor(
    private modalService: NgbModal,
    private formBuilder: UntypedFormBuilder,
    private atlasToast: AtlasToastService,
    private domainService: DomainService,
    private loaderService: LoaderService,
    private userService: UserService,
    private subaccountService: SubaccountService,
    private resellerSendersService: ResellerSendersService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    const that = this;
    this.domainService.getDomainState().subscribe(domain => {
      this.canManageAlphaSenders = domain.tpoaSenderManagement === 'NONE';

      const tableResellSendersAlphaColumnDefs: any = [
        {
          headerNameTranslate: 'sms_senders_table_company',
          field: 'companyName',
          sortable: false,
          cellRenderer: 'htmlRenderer',
          cellRendererParams: {
            content: params => (params && params.data && !params.data.external ? params.data.companyName : '')
          }
        }
      ];
      if (domain.tpoaSenderManagement === 'NONE' || domain.tpoaSenderManagement === 'DIRECT') {
        tableResellSendersAlphaColumnDefs.push(
          ...[
            {
              headerNameTranslate: 'sender_sender',
              field: 'sender',
              sortable: false
            },
            {
              headerNameTranslate: 'common_status',
              field: 'status',
              sortable: false,
              // resizable: false,
              // cellRenderer: 'translateRenderer',
              // cellRendererParams: {
              //   content: params => (params && params.data ? this.statusMap[params.data.status] : '')
              // }
              cellRenderer: 'htmlRenderer',
              cellRendererParams: {
                content: params => {
                  if (params && params.data) {
                    let badgeLabel;
                    this.translateService.get(this.statusMap[params.data.status]).subscribe(label => {
                      badgeLabel = label;
                    });
                    switch (params.data.status) {
                      case 'UNCONFIRMED':
                        return '<span class="badge badge-pending">' + badgeLabel + '</span>';
                        break;
                      case 'CONFIRMEDBYAGCOM':
                      case 'CONFIRMEDBYONEETERE':
                        return '<span class="badge badge-ok">' + badgeLabel + '</span>';
                        break;
                      case 'PRECONFIRMEDBYONEETERE':
                        return '<span class="badge badge-preok">' + badgeLabel + '</span>';
                        break;
                      case 'ERROR_DURING_UPLOAD':
                      case 'BLOCKEDBYAGCOM':
                      case 'BLOCKEDBYONEETERE':
                        return '<span class="badge badge-blocked">' + badgeLabel + '</span>';
                        break;
                      default:
                        return '<span class="badge badge-blocked">' + badgeLabel + '</span>';
                        break;
                    }
                  }
                  return '';
                }
              }
            },
            {
              headerNameTranslate: 'reseller_senders_new_subaccount',
              field: 'login',
              sortable: false
            },
            {
              headerNameTranslate: 'common_data_approvation',
              field: 'lastNotifyAliasDate',
              cellRenderer: 'htmlRenderer',
              sortable: false,
              // resizable: false,
              cellRendererParams: {
                content: params =>
                  params && params.data && params.data.lastNotifyAliasDate ? formateDateTime(params.data.lastNotifyAliasDate) : ''
              }
            }
          ]
        );
      }
      if (this.canManageAlphaSenders) {
        tableResellSendersAlphaColumnDefs.push(
          ...[
            {
              headerNameTranslate: 'common_actions',
              suppressCellFocus: true,
              cellRenderer: 'buttonGroupRenderer',
              cellRendererParams: {
                items: [
                  {
                    label: 'common_edit',
                    onClick: e => {
                      this.openmodalAddEditAlpha();
                    }
                  }
                ]
              },
              cellClass: ['button-group', 'text-end'],
              maxWidth: 82,
              field: '__actions'
            }
          ]
        );
      }
      this.tableResellSendersAlphaColumnDefs = tableResellSendersAlphaColumnDefs;
    });

    this.search.pipe(debounceTime(250)).subscribe(filter => {
      const body: ApiGetSubaccounts = {
        login: filter
      } as ApiGetSubaccounts;
      this.subaccountService.getSubaccounts(null, null, null, null, body).subscribe(subs => {
        this.itemsSubaccounts = [];
        for (const subaccount of subs.data) {
          this.itemsSubaccounts = [
            ...this.itemsSubaccounts,
            {
              value: subaccount.idUser,
              label: subaccount.login
            }
          ];
        }
        this.itemsSubaccounts.push();
      });
    });

    this.userSubscription = this.userService.getAuthenticationState().subscribe(loggedUser => {
      this.hasValidatedSendersList = loggedUser.hasValidatedSendersList();
      this.isCustomer = loggedUser.account.isCustomer;
      this.isSubAccount = !_.isUndefined(loggedUser.account.subaccount);
    });

    this.tableResellSendersNumericColumnDefs = [
      {
        headerNameTranslate: 'sender_sender',
        field: 'sender',
        sortable: false
      },
      {
        headerNameTranslate: 'common_status',
        // cellRenderer: 'translateRenderer',
        field: 'status',
        sortable: false,
        // resizable: false,
        // cellRenderer: 'translateRenderer',
        // cellRendererParams: {
        //   content: params => (params && params.data ? this.statusMap[params.data.status] : '')
        // }
        cellRenderer: 'htmlRenderer',
        cellRendererParams: {
          content: params => {
            if (params && params.data) {
              let badgeLabel;
              this.translateService.get(this.statusMap[params.data.status]).subscribe(label => {
                badgeLabel = label;
              });
              switch (params.data.status) {
                case 'UNCONFIRMED':
                  return '<span class="badge badge-pending">' + badgeLabel + '</span>';
                  break;
                case 'CONFIRMEDBYAGCOM':
                case 'CONFIRMEDBYONEETERE':
                  return '<span class="badge badge-ok">' + badgeLabel + '</span>';
                  break;
                case 'PRECONFIRMEDBYONEETERE':
                  return '<span class="badge badge-preok">' + badgeLabel + '</span>';
                  break;
                case 'ERROR_DURING_UPLOAD':
                case 'BLOCKEDBYAGCOM':
                case 'BLOCKEDBYONEETERE':
                  return '<span class="badge badge-blocked">' + badgeLabel + '</span>';
                  break;
                default:
                  return '<span class="badge badge-blocked">' + badgeLabel + '</span>';
                  break;
              }
            }
            return '';
          }
        }
      },
      {
        headerNameTranslate: 'reseller_senders_new_subaccount',
        field: 'login',
        sortable: false
      },
      {
        headerNameTranslate: 'common_data_approvation',
        field: 'lastNotifyAliasDate',
        cellRenderer: 'htmlRenderer',
        sortable: false,
        cellRendererParams: {
          content: params =>
            params && params.data && params.data.lastNotifyAliasDate ? formateDateTime(params.data.lastNotifyAliasDate) : ''
        }
      },
      {
        headerNameTranslate: 'common_actions',
        suppressCellFocus: true,
        cellRenderer: 'buttonGroupRenderer',
        cellRendererParams: {
          items: [
            {
              label: 'common_delete',
              onClick: e => {
                this.openModalDeleteNumeric(e);
              }
            }
          ]
        },
        cellClass: ['button-group', 'text-end'],
        maxWidth: 82,
        field: '__actions'
      }
    ];

    this.tableResellSendersAlphaGridOptions = AtlasGridOptions.deserialize({
      onGridReady: (event: GridReadyEvent) => {
        this.gridAnimationStateAlpha = 'show';
      },
      pagination: true,
      paginationPageSize: this.paginationPageSize,
      loadFunction: this.reloadTableListAlpha.bind(that)
    });

    this.tableResellSendersNumericGridOptions = AtlasGridOptions.deserialize({
      onGridReady: (event: GridReadyEvent) => {
        this.gridAnimationStateNumeric = 'show';
      },
      pagination: true,
      paginationPageSize: this.paginationPageSize,
      loadFunction: this.reloadTableListNumeric.bind(that)
    });

    this.addResellSenderAlphaForm = this.formBuilder.group({
      subaccount: [, [Validators.required]],
      sender: ['', [Validators.required, Validators.maxLength(11)]],
      contactName: ['', [Validators.required]],
      contactSurname: ['', [Validators.required]],
      companyName: ['', [Validators.required]],
      contactAddress: ['', [Validators.required]],
      contactPostalCode: ['', [Validators.required]],
      contactCity: ['', [Validators.required]],
      vatNumber: ['', [Validators.required]],
      fiscalCode: ['', [Validators.required]],
      // contactType: ['', [Validators.required]],
      contactInfo: ['', [Validators.required, Validators.email]],
      authorize: ['', [Validators.required]]
    });
    this.addResellSenderNumericForm = this.formBuilder.group({
      subaccount: ['', [Validators.required]],
      number: ['', [Validators.required, Validators.pattern(/^(\+)?[0-9]{5,15}$/)]]
    });

    this.confirmNumericSenderForm = this.formBuilder.group({
      pin: ['', [Validators.required]]
    });

    this.itemsSubaccounts.push({
      value: 0,
      label: 'reseller_senders_new_subaccount_all'
    });

    // this.subaccountService.getSubaccounts().subscribe(subs => {
    //   for (const subaccount of subs.data) {
    //     this.itemsSubaccounts = [
    //       ...this.itemsSubaccounts,
    //       {
    //         value: subaccount.idUser,
    //         label: subaccount.login
    //       }
    //     ];
    //   }
    // });
  }

  // table alpha-sender
  reloadTableListAlpha(startRow?, endRow?, sort?) {
    this.loaderService.show();
    return this.resellerSendersService
      .getAgcomListSubaccountSenders(true, 1 + startRow / (endRow - startRow), endRow - startRow, 'ALPHA_NUMERIC')
      .pipe(finalize(() => this.loaderService.hide()));
  }

  reloadTableListNumeric(startRow?, endRow?, sort?) {
    this.loaderService.show();
    return this.resellerSendersService
      .getAgcomListSubaccountSenders(true, 1 + startRow / (endRow - startRow), endRow - startRow, 'NUMERIC')
      .pipe(finalize(() => this.loaderService.hide()));
  }

  onScrollToEnd() {
    this.scrollPageSubs++;
    this.subaccountService.getSubaccounts(this.scrollPageSubs).subscribe(subs => {
      for (const subaccount of subs.data) {
        this.itemsSubaccounts = [
          ...this.itemsSubaccounts,
          {
            value: subaccount.idUser,
            label: subaccount.login
          }
        ];
      }
    });
  }

  onSearch($event) {
    this.search.next($event.term);
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }

  openModalDeleteAlpha(e): void {
    this.subSenderToDelete = e;
    this.modalDeleteAlphaModal = this.modalService.open(this.modalDeleteAlpha);
    this.modalDeleteAlphaModal.result.then(
      result => {},
      reason => {}
    );
  }
  modalDeleteSubSenderAlphaForm(): void {
    const that = this;
    this.alphaGrid.showLoading();

    this.resellerSendersService.removeAgcomResellerSender(this.subSenderToDelete).subscribe(x => {
      that.alphaGrid.refresh();
    });

    this.modalDeleteAlphaModal.close();
  }

  openModalDeleteNumeric(e): void {
    this.subSenderToDelete = e;
    this.modalDeleteNumericModal = this.modalService.open(this.modalDeleteNumeric);
    this.modalDeleteNumericModal.result.then(
      result => {},
      reason => {}
    );
  }

  modalDeleteNumericForm(): void {
    const that = this;
    this.numericGrid.showLoading();
    this.resellerSendersService.removeAgcomResellerSender(this.subSenderToDelete).subscribe(x => {
      that.numericGrid.refresh();
    });

    this.modalDeleteNumericModal.close();
  }

  openmodalAddEditAlphaDisabled(e?): void {
    this.modalAddEditAlphaDisabledModal = this.modalService.open(this.modalAddEditAlphaDisabled);
    this.modalAddEditAlphaDisabledModal.result.then(
      result => {},
      reason => {}
    );
  }

  openmodalAddEditAlpha(): void {
    this.itemsSubaccounts = [];
    this.scrollPageSubs = 1;
    this.subaccountService.getSubaccounts().subscribe(subs => {
      for (const subaccount of subs.data) {
        this.itemsSubaccounts = [
          ...this.itemsSubaccounts,
          {
            value: subaccount.idUser,
            label: subaccount.login
          }
        ];
      }
    });

    if (!this.isCustomer && !this.isSubAccount) {
      this.openmodalAddEditAlphaDisabled();
      return;
    }

    this.addResellSenderAlphaForm.reset();
    this.modalAddEditAlphaModal = this.modalService.open(this.modalAddEditAlpha);
    this.modalAddEditAlphaModal.result.then(
      result => {},
      reason => {
        this.alphaGrid.refresh();
      }
    );
  }

  modalAddEditAlphaForm(): void {
    if (!this.addResellSenderAlphaForm.valid) {
      validateFormGroup(this.addResellSenderAlphaForm);
      return;
    }

    const subValue = this.addResellSenderAlphaForm.get('subaccount').value;
    let toAllSubaccounts = false;
    let idSubaccount = null;

    if (subValue === 0) {
      toAllSubaccounts = true;
    } else {
      idSubaccount = subValue;
    }

    this.senderToConfirm = ResellerSubSenderAgcom.deserialize({
      toAllSubaccounts,
      idSubaccount,
      agcomTpoaAlias: {
        sender: this.addResellSenderAlphaForm.get('sender').value,
        tpoaUser: {
          contactName: this.addResellSenderAlphaForm.get('contactName').value,
          contactSurname: this.addResellSenderAlphaForm.get('contactSurname').value,
          companyName: this.addResellSenderAlphaForm.get('companyName').value,
          contactAddress: this.addResellSenderAlphaForm.get('contactAddress').value,
          contactPostalCode: this.addResellSenderAlphaForm.get('contactPostalCode').value,
          contactCity: this.addResellSenderAlphaForm.get('contactCity').value,
          vatNumber: this.addResellSenderAlphaForm.get('vatNumber').value,
          fiscalCode: this.addResellSenderAlphaForm.get('fiscalCode').value,
          contactType: 'PEC',
          contactInfo: this.addResellSenderAlphaForm.get('contactInfo').value
        }
      }
    });
    this.alphaGrid.showLoading();
    let subscription;
    subscription = this.resellerSendersService.addAgcomResellSenderAlpha(this.senderToConfirm);
    subscription.subscribe(data => {
      if (data.agcomStatus && data.agcomStatus === 'ERROR') {
        this.atlasToast.error('common_error', 'error_' + -data.errorCode);
      } else {
        this.alphaGrid.refresh();
        // REQUIRES_AGCOM_CONFIRM
        this.atlasToast.success('common_success', null);
        this.modalAddEditAlphaModal.close();
        this.addResellSenderAlphaForm.reset();
      }
    });
  }

  openModalAddNumeric(): void {
    this.itemsSubaccounts = [];
    this.scrollPageSubs = 1;
    this.subaccountService.getSubaccounts().subscribe(subs => {
      for (const subaccount of subs.data) {
        this.itemsSubaccounts = [
          ...this.itemsSubaccounts,
          {
            value: subaccount.idUser,
            label: subaccount.login
          }
        ];
      }
    });

    this.addResellSenderNumericForm.reset();
    this.modalAddNumericModal = this.modalService.open(this.modalAddNumeric);
    this.modalAddNumericModal.result.then(
      result => {},
      reason => {
        this.numericGrid.refresh();
      }
    );
  }

  modalAddNumericForm(): void {
    if (!this.addResellSenderNumericForm.valid) {
      validateFormGroup(this.addResellSenderNumericForm);
      return;
    }

    const subValue = this.addResellSenderNumericForm.get('subaccount').value;
    let toAllSubaccounts = false;
    let idUser = null;

    if (subValue === 'all') {
      toAllSubaccounts = true;
    } else {
      idUser = subValue;
    }

    this.senderToConfirm = ResellerSubSenderAgcom.deserialize({
      toAllSubaccounts,
      idUser,
      sender: this.addResellSenderNumericForm.get('number').value
    });
    this.numericGrid.showLoading();
    this.resellerSendersService.addAgcomResellerSenderNumeric(this.senderToConfirm).subscribe(data => {
      this.atlasToast.success('common_success', null);
    });
    this.modalAddNumericModal.close();
    this.addResellSenderNumericForm.reset();
  }
}
